import { setupWorker } from 'msw/browser';
import { kymw02Handlers } from './handlers/kymw02/kymw02-handlers';
import { kymw06Handlers } from './handlers/kymw06/kymw06-handlers';
import { kymw08Handlers } from './handlers/kymw08/kymw08-handlers';
import { kymw09Handlers } from './handlers/kymw09/kymw09-handlers';
import { kymw10Handlers } from './handlers/kymw10-handlers';
import { kymw11Handlers } from './handlers/kymw11/kymw11-handlers';
import { kymw12Handlers } from './handlers/kymw12/kymw12-handlers';
import { kymw13Handlers } from './handlers/kymw13/kymw13-handlers';
import { kymw1301Handlers } from './handlers/kymw13/kymw1301-handlers';
import { kymw14Handlers } from './handlers/kymw14/kymw14-handlers';
import { kymw15Handlers } from './handlers/kymw15/kymw15-handlers';
import { kymw1700Handlers } from './handlers/kymw17/kymw1700-handlers';
import { kymw1705Handlers } from './handlers/kymw17/kymw1705-handlers';
import { kymw1707Handlers } from './handlers/kymw17/kymw1707-handlers';
import { kymw1708Handlers } from './handlers/kymw17/kymw1708-handlers';
import { kymw21Handlers } from './handlers/kymw21/kymw21-handlers';
import { kymw20Handlers } from './handlers/kymw20/kymw20-handlers';
import { kymw44Handlers } from './handlers/kymw44/kymw44-handlers';
import { kymw46Handlers } from './handlers/kymw46/kymw46-handlers';
import { kymw47Handlers } from './handlers/kymw47-handlers';
import { kymw48Handlers } from './handlers/kymw48-handlers';
import { kymw50Handlers } from './handlers/kymw50/kymw50-handlers';
import { kymw53Handlers } from './handlers/kymw53/kymw53-handlers';
import { kymw54Handlers } from './handlers/kymw54/kymw54-handlers';
import { kymw59Handlers } from './handlers/kymw59/kymw59-handlers';
import { kymw60Handlers } from './handlers/kymw60/kymw60-handlers';
import { kymw6001Handlers } from './handlers/kymw60/kymw6001-handlers';
import { kymw68Handlers } from './handlers/kymw68-handlers';
import { kymw69Handlers } from './handlers/kymw69/kymw69-handlers';
import { kymw70Handlers } from './handlers/kymw70/kymw70-handlers';
import { kymw72Handlers } from './handlers/kymw72/kymw72-handlers';
import { kymw71Handlers } from './handlers/kymw71/kymw71-handlers';
import { kymw7000Handlers } from './handlers/kymw7000/kymw7000-handlers';
import { kymw7001Handlers } from './handlers/kymw7001-handlers';
import { kymw73Handlers } from './handlers/kymw73/kymw73-handlers';
import { kymw74Handlers } from './handlers/kymw74/kymw74-handlers';
import { kymw75Handlers } from './handlers/kymw75/kymw75-handlers';
import { kymw9000Handlers } from './handlers/kymw90/kymw9000-handlers';
import { kymw9003Handlers } from './handlers/kymw90/kymw9003-handlers';
import { kymw9004Handlers } from './handlers/kymw90/kymw9004-handlers';
import { kymw9005Handlers } from './handlers/kymw90/kymw9005-handler';
import { kymw9008Handlers } from './handlers/kymw90/kymw9008-handlers';
import { kymw9007Handlers } from './handlers/kymw90/kymw9007-handlers';
import { kymw9009Handlers } from './handlers/kymw90/kymw9009-handlers';
import { kymw9010Handlers } from './handlers/kymw90/kymw9010-handler';
import { kymw0001Handlers } from './handlers/kymw00/kymw0001-handlers';
import { kymw0003Handlers } from './handlers/kymw0003/kymw0003-handlers';
import { kymw03Handlers } from './handlers/kymw03/kymw03-handlers';
import { kymw45Handlers } from './handlers/kymw45/kymw45-handlers';
import { kymw0cHandlers } from './handlers/kymw0c/kymw0c-handlers';
import { kymw1001Handlers } from './handlers/kymw10/kymw10-handlers';
import { kymwHandlers } from './handlers/kymw-handlers';
import { kymw9011Handlers } from './handlers/kymw90/kymw9011-handler';
import { kymw1709Handlers } from './handlers/kymw17/kymw1709-handlers';
import { kymw1317Handlers } from './handlers/kymw13/kymw1317-handlers';
import { kymw0907Handlers } from './handlers/kymw09/kymw0907-handlers';

export const worker = setupWorker(
  ...kymw02Handlers,
  ...kymw06Handlers,
  ...kymw08Handlers,
  ...kymw09Handlers,
  ...kymw10Handlers,
  ...kymw1001Handlers,
  ...kymw11Handlers,
  ...kymw12Handlers,
  ...kymw13Handlers,
  ...kymw1301Handlers,
  ...kymw14Handlers,
  ...kymw15Handlers,
  ...kymw1700Handlers,
  ...kymw1705Handlers,
  ...kymw1707Handlers,
  ...kymw1708Handlers,
  ...kymw1709Handlers,
  ...kymw21Handlers,
  ...kymw20Handlers,
  ...kymw44Handlers,
  ...kymw45Handlers,
  ...kymw46Handlers,
  ...kymw44Handlers,
  ...kymw68Handlers,
  ...kymw70Handlers,
  ...kymw47Handlers,
  ...kymw48Handlers,
  ...kymw50Handlers,
  ...kymw53Handlers,
  ...kymw54Handlers,
  ...kymw59Handlers,
  ...kymw69Handlers,
  ...kymw60Handlers,
  ...kymw6001Handlers,
  ...kymw70Handlers,
  ...kymw72Handlers,
  ...kymw71Handlers,
  ...kymw7000Handlers,
  ...kymw7001Handlers,
  ...kymw73Handlers,
  ...kymw74Handlers,
  ...kymw75Handlers,
  ...kymw9000Handlers,
  ...kymw9003Handlers,
  ...kymw9004Handlers,
  ...kymw9005Handlers,
  ...kymw9008Handlers,
  ...kymw9007Handlers,
  ...kymw9009Handlers,
  ...kymw9010Handlers,
  ...kymw0001Handlers,
  ...kymw0003Handlers,
  ...kymw03Handlers,
  ...kymw0cHandlers,
  ...kymwHandlers,
  ...kymw9011Handlers,
  ...kymw1317Handlers,
  ...kymw0907Handlers,
);
